import React, { useState, useEffect } from 'react';
import {
  Grid,
  Column,
  DataTable,
  Button,
  Pagination,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableCell,
  TableToolbar,
  TableToolbarContent,
  TableToolbarSearch,
  TableExpandRow,
  TableExpandedRow,
  TableExpandHeader,
  Theme,
} from '@carbon/react';
import { getResoucesForViews } from '../../services/services';
import CommodityHeader from '../../components/Header';
import { useNavigate } from "react-router-dom";

const headers = [
  {
    key: 'ctrycode',
    header: 'Country',
  },
  {
    key: 'compcode',
    header: 'Company',
  },
  {
    key: 'invonumb',
    header: 'Internal Reference',
  },
  {
    key: 'invoice',
    header: 'Invoice',
  },
  {
    key: 'nameapprover',
    header: 'Approver Name',
  },
  {
    key: 'mailapprover',
    header: 'Approver Mail',
  },
  {
    key: 'daystomailapprover',
    header: 'Days to Mail',
  },
  {
    key: 'namemanager',
    header: 'Manager Name',
  },
  {
    key: 'mailmanager',
    header: 'Manager Mail',
  },
  {
    key: 'daystomailmanager',
    header: 'Days to Mail',
  },
  {
    key: 'namedirector',
    header: 'Director Name',
  }
];

const FollowUpLog = () => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [rows, setRows] = useState([]);
  const [allRows, setAllRows] = useState([]);
  const navigate = useNavigate();
  
  const changePaginationState = (pageInfo) => {
    if (page !== pageInfo.page) {
      setPage(pageInfo.page)
    }
    if (pageSize !== pageInfo.pageSize) {
      setPageSize(pageInfo.pageSize)
    }
  }
  const getFollowUpList = async (request) => await getResoucesForViews(request)
  .then(response => {
    if(response.status === 200){
      response.json()
        .then(response => {
          parserIdInResponse(response);
        })
    }    
  });

  const goHomeScreen = () => {
    navigate('/home')
  };
  
  const parserIdInResponse = (response) => {
    const resParsedAll = response.map((res, i) => {
      const parsed = {}; 
      parsed["id"] = i.toString();
      parsed["ctrycode"] = res.ctrycode;
      parsed["compcode"] = res.compcode;
      parsed["invonumb"] = res.invonumb;
      parsed["supplier"] = res.supplier;
      parsed["invoice"] = res.rcpowayb;
      parsed["nameapprover"] = res.approverName;
      parsed["mailapprover"] = res.approverMail;
      parsed["daystomailapprover"] = res.diasFaltantesAprobador;
      parsed["namemanager"] = res.managerName;
      parsed["mailmanager"] = res.managerMail;
      parsed["daystomailmanager"] = res.diasFaltantesManager;
      parsed["namedirector"] = res.directorName;
      parsed["maildirector"] = res.directorMail;
      parsed["daystomaildirector"] = res.diasFaltantesDirector;
      parsed["nameCFO"] = res.nameCFO;
      parsed["mailCFO"] = res.mailCFO;
      parsed["datetoCFO"] = res.fupDayOfWeek;
      parsed["statusCFO"] = res.statusCFO;

      return parsed;
    });
    setRows(resParsedAll);
    setAllRows(resParsedAll);
  }

  useEffect(() => {
    let request = {};
    request.viewName = 'logFollowUp';
    getFollowUpList(request);
    
  }, [0]);


  return (
    <>
      <h2 className="table-title">Log Follow Up</h2>
      <Theme theme="g90">
        <CommodityHeader />
      </Theme>
      <Grid>
        <Column lg={16} >
        <Button className='style-bttbackID' size="lg" onClick={goHomeScreen}>Back to Home</Button>
          <DataTable            
            rows={rows}
            allRows={allRows}
            headers={headers}
            useZebraStyles
            render={({
              rows,
              headers,
              getHeaderProps,
              getRowProps,
              getTableProps,
              onInputChange
            }) => (
              <TableContainer>                
                <TableToolbar>
                  <TableToolbarContent>
                    <TableToolbarSearch persistent size="sm" onChange={onInputChange} />                    
                  </TableToolbarContent>
                </TableToolbar>
                <Table {...getTableProps()}>
                  <TableHead>
                    <TableRow>
                      <TableExpandHeader />
                      {headers.map(header => (
                        <TableHeader {...getHeaderProps({ header })}>
                          {header.header}
                        </TableHeader>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.slice((page - 1) * pageSize).slice(0, pageSize).map((row, i) => (
                      <>
                      <React.Fragment key={row.id}>
                        <TableExpandRow {...getRowProps({ row })}>
                          {row.cells.map(cell => (
                            <TableCell key={cell.id}>{cell.value}</TableCell>
                          ))}
                        </TableExpandRow>
                          <TableExpandedRow className={"style-zebra"} colSpan={headers.length + 1}>
                            <TableRow colSpan={headers.length+1}>
                              <TableRow className="style-inside-row"><strong>•  Mail Director: </strong> {allRows[i].maildirector}</TableRow>
                              <TableRow className="style-inside-row2"><strong>•  Days to Mail: </strong> {allRows[i].daystomaildirector}</TableRow>
                              <TableRow className="style-inside-row"><strong>•  Name CFO: </strong> {allRows[i].nameCFO}</TableRow>
                              <TableRow className="style-inside-row2"><strong>•  Mail CFO: </strong> {allRows[i].mailCFO}</TableRow>
                              <TableRow className="style-inside-row"><strong>•  Date to CFO: </strong> {allRows[i].datetoCFO}</TableRow>
                              <TableRow className="style-inside-row2"><strong>•  Status CFO: </strong> {allRows[i].statusCFO}</TableRow>
                            </TableRow>
                          </TableExpandedRow>
                      </React.Fragment>
                      </>
                    ))}
                  </TableBody>
                </Table>
                <Pagination
                  onChange={changePaginationState}

                  backwardText="Previous page"
                  forwardText="Next page"
                  itemsPerPageText="Items per page:"
                  page={page}
                  pageNumberText="Page Number"
                  pageSize={pageSize}
                  pageSizes={[
                    10,
                    25,
                    50,
                    100,
                  ]}
                  totalItems={rows.length}
                />
              </TableContainer>
            )}
          />


        </Column>
      </Grid>
    </>
  );
};

export default FollowUpLog;